import { render, staticRenderFns } from "./SharedLinkAccessDeniedPage.vue?vue&type=template&id=d186a710&scoped=true"
import script from "./SharedLinkAccessDeniedPage.vue?vue&type=script&lang=ts"
export * from "./SharedLinkAccessDeniedPage.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkAccessDeniedPage.vue?vue&type=style&index=0&id=d186a710&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d186a710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d186a710')) {
      api.createRecord('d186a710', component.options)
    } else {
      api.reload('d186a710', component.options)
    }
    module.hot.accept("./SharedLinkAccessDeniedPage.vue?vue&type=template&id=d186a710&scoped=true", function () {
      api.rerender('d186a710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/SharedLinkAccessDeniedPage.vue"
export default component.exports